import React from 'react';
import ServiceContactForm from '../components/ServiceContactForm';
import { motion } from 'framer-motion';
import { Mail, MapPin } from 'lucide-react';

const Contact = () => {
  return (
    <div className="bg-white pt-16">
      {/* Hero Section */}
      <section className="py-24 px-4 lg:px-8 bg-black text-white">
        <div className="max-w-6xl mx-auto text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold mb-6 text-light-pink">Contact Us</h1>
            <p className="text-xl md:text-2xl text-grey max-w-4xl mx-auto leading-relaxed">
              We'd love to hear from you. Let's start a conversation about your next project.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Contact Info and Contact Form Combined */}
      <section className="py-24 px-4 lg:px-8 bg-white">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 mb-16">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="flex items-start gap-4"
            >
              <div className="bg-light-pink p-4 rounded-full">
                <Mail size={32} className="text-black" />
              </div>
              <div>
                <h3 className="text-xl font-semibold mb-2">Email</h3>
                <a href="mailto:info@syncorellc.com" className="text-dark-grey hover:text-light-pink transition-colors text-lg">
                  info@syncorellc.com
                </a>
              </div>
            </motion.div>
            
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.1 }}
              className="flex items-start gap-4"
            >
              <div className="bg-mid-blue p-4 rounded-full">
                <MapPin size={32} className="text-white" />
              </div>
              <div>
                <h3 className="text-xl font-semibold mb-2">Office</h3>
                <p className="text-dark-grey text-lg">                  
                  445 HAYES IRVINE, CA 92620
                </p>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Contact Form */}
      <ServiceContactForm serviceName="Contact Page" />

      {/* Additional Info */}
      <section className="py-24 px-4 lg:px-8 bg-grey">
        <div className="max-w-6xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center"
          >
            <h2 className="text-3xl md:text-4xl font-bold mb-6">Why Work With Us?</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-12">
              <div className="bg-white rounded-lg p-6">
                <h3 className="text-xl font-bold mb-3">Expert Team</h3>
                <p className="text-dark-grey">
                  Our team consists of seasoned professionals with years of experience in their respective fields.
                </p>
              </div>
              <div className="bg-white rounded-lg p-6">
                <h3 className="text-xl font-bold mb-3">Proven Track Record</h3>
                <p className="text-dark-grey">
                  With 250+ successful projects delivered, we have the experience to handle any challenge.
                </p>
              </div>
              <div className="bg-white rounded-lg p-6">
                <h3 className="text-xl font-bold mb-3">Client-Focused Approach</h3>
                <p className="text-dark-grey">
                  Your success is our priority. We work closely with you throughout the entire process.
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
